/**
 * Store builds below the minimum version (`APP_VERSION_TOO_LOW`) are sent to this page. It links to the store.
 * Separate from the OTA update page (`OTA_UPDATE_PAGE_PATH`), which installs a newer web bundle.
 */
export const APP_UPDATE_PAGE_PATH = '/update-app';
